import React, { useState, useEffect } from 'react';
import { Table, Space, Button, notification, Modal } from 'antd';
import { FixedTrackingColumns } from "./ThirdPartyErrorHandlingTabColumns";
import { ProTable } from '@ant-design/pro-components';
import {
    useThirdPartyDisputeBillingDetailsMutation,
    useThirdPartyUpdateUidMutation,
} from '../../../features/api/apiSlice';
import UidEditModal from "../../billingDetails/UidEditModal";
import { useSelector } from "react-redux";

function ThirdPartyUIDErrorTab({ data, loading, searchData, setSearchData, currentPage, setCurrentPage, pageSize, setPageSize, UIDData, refetch }) {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [uidEditModalVisible, setUidEditModalVisible] = useState(false);
    const [openSurcharge, setOpenSurcharge] = useState(false);
    const [modalContent, setModalContent] = useState(null);
    const currUser = useSelector((state) => state.auth.user);
    const [updateUid, {
        isSuccess: isUpdateUidSuccess,
        isError: isUpdateUidError,
        error: updateUidError,
        isLoading: isUpdateUidLoading,
        isFetching: isUpdateUidFetching
    }] = useThirdPartyUpdateUidMutation();
    const [thirdPartyDisputeBillingDetails, {
        isLoading: disputeLoading,
        isSuccess: isDisputeSuccess,
        isError: isDisputeError,
        error: disputeError,
    }] = useThirdPartyDisputeBillingDetailsMutation();
    useEffect(() => {
        setSelectedRowKeys([]);
    }, [searchData])
    useEffect(() => {
        if (isDisputeSuccess) {
            notification.success({
                message: 'Success',
                description: 'Dispute success',
            })
            setSelectedRowKeys([]);
            refetch();
        }
        if (isDisputeError) {
            notification.error({
                message: 'Error',
                description: disputeError?.data?.error ?? 'Dispute failed for unknown reason',
            })
        }
    }, [isDisputeSuccess, isDisputeError, disputeError])
    useEffect(() => {
        if (isUpdateUidSuccess) {
            notification.success({
                message: "Success",
                description: "修改成功",
            });
            setUidEditModalVisible(false);
            setSelectedRowKeys([]);
            refetch();
        }
        if (isUpdateUidError) {
            notification.error({
                message: "Error",
                description: updateUidError?.data?.error || "修改失败",
            });
        }
    }, [isUpdateUidSuccess, isUpdateUidError])

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows);
        },
        selectedRowKeys,
    };
    const disputeButtonHandler = () => {
        const keys = selectedRowKeys;
        if (keys.length === 0) {
            return notification.error({
                message: 'Error',
                description: '请选择至少一条记录',
            })
        }
        thirdPartyDisputeBillingDetails({ ids: keys });
    }
    const uidEditButtonHandler = () => {
        if (selectedRowKeys.length === 0) {
            return notification.error({
                message: "Error",
                description: "请选择至少一条记录",
            });
        }
        const notUidRows = selectedRows.filter(row => row.status !== 'UID异常');
        if (notUidRows.length > 0) {
            return notification.error({
                message: "Error",
                description: "请选择UID异常的记录",
            });
        }
        setUidEditModalVisible(true);
    }
    const uidEditModalSubmitHandler = (values) => {
        const newUid = values?.uid;
        const formData = new FormData();
        formData.append('uid', newUid);
        formData.append('ids', selectedRowKeys);
        updateUid(formData);
    }
    const columns = FixedTrackingColumns(setOpenSurcharge, setModalContent);
    const surcharge_columns = [{
        title: '费用类型',
        dataIndex: 'type',
        key: 'type'
    }, {
        title: '金额',
        dataIndex: 'amount',
        key: 'amount'
    }];
    const renderModalTable = () => {
        return <Table columns={surcharge_columns} dataSource={modalContent} pagination={false} />;
    };
    return (
        <Space direction="vertical" style={{ display: 'flex'}}>
            <ProTable
                search={false}
                columns={columns}
                rowKey={record => record.id}
                loading={loading}
                dataSource={data?.results}
                rowSelection={rowSelection}
                pagination={{
                    showSizeChanger: true,
                    pageSize: pageSize,
                    current: currentPage,
                    total: data?.count,
                    onChange: (page, pageSize) => {
                        setCurrentPage(page);
                        setPageSize(pageSize);
                        setSelectedRowKeys([]);
                    },
                    onShowSizeChange: (current, size) => {
                        setCurrentPage(current);
                        setPageSize(size);
                        setSelectedRowKeys([]);
                    },
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                }}
                scroll={{ x: 'max-content' }}
                options={{
                    reload: () => refetch(),
                }}
                toolbar={{
                    title: ' ',
                    search: false,
                    actions: [
                        (currUser.button_permission?.includes('third_party_uid_error_update_uid') && <Button type="primary" onClick={uidEditButtonHandler}>修改UID</Button>),
                        (currUser.button_permission?.includes('third_party_uid_error_dispute') && <Button loading={disputeLoading} onClick={disputeButtonHandler} >Dispute</Button>),
                    ],
                }}
            />
            <UidEditModal
                open={uidEditModalVisible}
                setOpen={setUidEditModalVisible}
                onSubmit={uidEditModalSubmitHandler}
                loading={isUpdateUidFetching || isUpdateUidLoading}
                success={isUpdateUidSuccess}
            />
            <Modal
                title="附加费详情"
                open={openSurcharge}
                onOk={() => setOpenSurcharge(false)}
                onCancel={() => setOpenSurcharge(false)}
                width={800}
            >
                {renderModalTable()}
            </Modal>
        </Space>
    )
}

export default ThirdPartyUIDErrorTab;